/* eslint-disable react/require-default-props */
import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Stack,
  Text,
  useToast,
} from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colors from '../../../../styles/colors';
import { useStoreActions, useStoreState } from '../../../../models/hooks';
import { usePermissionGroup } from './usePermissionGroup';
import PermissionGroup from './PermissionGroup';
import { EmployeePermissionsEnum } from './teamPermission.constant';

interface TeamPermissionModalProps {
  recruiterId: string;
  isOpen: boolean;
  onClose: () => void;
  permissions?: string[];
}

function TeamPermissionModal({ recruiterId, isOpen, onClose, permissions }: TeamPermissionModalProps) {
  const { t } = useTranslation('team');
  const toast = useToast();
  const { user } = useStoreState((state) => state.app);
  const { updateRecruiterPermission } = useStoreActions((state) => state.profileManagement);

  const [isUpdating, setUpdating] = React.useState(false);

  const { permissionGroups } = usePermissionGroup();

  const [formData, setFormData] = React.useState<EmployeePermissionsEnum[]>([]);
  React.useEffect(() => {
    setFormData((permissions || []) as EmployeePermissionsEnum[]);
  }, [permissions]);
  const handlePermissionSave = () => {
    setUpdating(true);
    updateRecruiterPermission({
      recruiterId,
      accountId: user?.account ?? '',
      payload: {
        permissions: formData,
      },
    })
      .then(() => {
        toast({
          description: t('permissionModal.successMessage'),
          status: 'success',
          isClosable: true,
        });
        onClose();
      })
      .finally(() => {
        setUpdating(false);
      });
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered closeOnOverlayClick={!isUpdating}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Stack spacing={0}>
              <Text fontSize="2xl">{t('permissionModal.title')}</Text>
              <Text fontSize="sm" color={colors.gray[300]} fontWeight="normal">
                {t('permissionModal.subTitle')}
              </Text>
              <Spacer flexBasis={3} />
              <Divider />
            </Stack>
          </ModalHeader>
          <ModalBody>
            <Stack divider={<Divider />} spacing={4}>
              {permissionGroups.map((group) => (
                <PermissionGroup
                  key={group.heading}
                  {...group}
                  value={formData}
                  onChange={(value) => {
                    setFormData(value);
                  }}
                />
              ))}
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={onClose} disabled={isUpdating}>
              {t('permissionModal.cancelBtn')}
            </Button>
            <Button colorScheme="blue" disabled={isUpdating} isLoading={isUpdating} onClick={handlePermissionSave}>
              {t('permissionModal.confirmBtn')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default React.memo(TeamPermissionModal);
